export const extractStackedSeriesData = function (
  series,
  alias,
  categoriesCount
) {
  const index = series.findIndex((o) => o.alias === alias);

  if (index < 0) return;

  const subSeries = series[index];
  const res = [];

  for (let i = 0; i < categoriesCount; i++) res.push(subSeries.values[i]);

  return {
    name: subSeries.name,
    data: res,
  };
};

export const sortStackedSeriesData = function (dto) {
  const categoriesLength = dto.categories.length;
  const seriesLength = dto.series.length;
  let temp = [];
  let orderedCategories = [];

  // Объединение массива МО и массива количества заявлений в один объект, а затем в массив
  for (var i = 0; i < categoriesLength; i++) {
    temp.push({
      mo: dto.categories[i],
      values: [],
    });

    for (var j = 0; j < seriesLength; j++) {
      temp[i].values.push(dto.series[j].values[i]);
    }
  }

  // Сортировка по убыванию по сумме всех заявлений
  let orderedTemp = temp.sort(function (a, b) {
    const firstSum = a.values.reduce((x, y) => x + y);
    const secondSum = b.values.reduce((x, y) => x + y);

    return firstSum < secondSum ? 1 : -1;
  });

  // перекладываем отсортированные категории
  for (var k = 0; k < categoriesLength; k++) {
    orderedCategories.push(orderedTemp[k].mo);
  }

  dto.categories = orderedCategories;

  // Перекладываем отсортированные значения для количества заявлений по категориям
  for (var l = 0; l < seriesLength; l++) {
    let tmp = [];

    for (var p = 0; p < categoriesLength; p++) {
      tmp.push(orderedTemp[p].values[l]);
    }

    dto.series[l].values = tmp;
  }

  return dto;
};
